import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import { TextField } from "@website/ui/text-field";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { Header } from "@website/widget/login/components";
import styles from "@website/widget/login/components/phone-number-card/phone-number-card.module.scss";
import { PhoneNumberCardPropertiesType } from "@website/widget/login/components/phone-number-card/phone-number-card.types";
import { usePhoneNumberCard } from "@website/widget/login/components/phone-number-card/use-phone-number-card";
import { FC } from "react";

export const PhoneNumberCard: FC<PhoneNumberCardPropertiesType> = (
  properties
) => {
  const { onClose } = properties;
  const {
    phoneNumber,
    onChangePhoneNumber,
    onSubmitPhoneNumber,
    isLoading,
    error,
    headerTitle,
    modalTitle,
    loginBack,
    isForceLogin,
    backButtonText
  } = usePhoneNumberCard(properties);

  return (
    <div className={styles["container"]}>
      <Header onClose={onClose} title={headerTitle} />
      <div className={styles["title"]}>{modalTitle}</div>
      <form
        className="w-full"
        onSubmit={isLoading ? undefined : onSubmitPhoneNumber}
      >
        <div className={styles["input"]}>
          <TextField
            StartIcon={<MaterialIcon name="phone_iphone" />}
            error={Boolean(error)}
            fullWidth
            helperText={error}
            onChange={onChangePhoneNumber}
            placeholder="شماره موبایل"
            value={phoneNumber}
            autoFocus
            inputMode="numeric"
            type="text"
          />
        </div>

        <div className={styles["info"]}>
          <span className={styles["info-icon"]}>
            <MaterialIcon name="info" variant="outlined" />
          </span>
          ورود و استفاده از {replaceSnappTripBasedOnChannel("اسنپ‌تریپ")} به
          معنای پذیرش
          <a className={styles["info-rules"]} href="/policy">
            قوانین و مقررات
          </a>
          آن می باشد.
        </div>
        <div className={styles["footer"]}>
          <Button
            color="secondary"
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            {isLoading ? <Loading color="white" size="lg" /> : "تایید و ادامه"}
          </Button>
          {isForceLogin && (
            <Button
              color="secondary"
              fullWidth
              onClick={loginBack}
              size="large"
              type="button"
              variant="outline"
            >
              {backButtonText}
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};
